import { useState } from 'react'
import { Link } from 'react-router-dom'

const phrases = [
  {
    quote: 'Validea te ayuda a descubrir si tu idea tiene tracción real antes de invertir tiempo y dinero.',
    author: 'Sofía Méndez',
    role: 'Fundadora de StartUpX',
  },
  {
    quote: 'Prioriza las funcionalidades que tus usuarios realmente quieren con datos, no suposiciones.',
    author: 'Pablo Torres',
    role: 'Product Manager',
  },
  {
    quote: 'Valida tu MVP en días, no meses, y toma decisiones basadas en evidencia.',
    author: 'Laura Ruiz',
    role: 'Emprendedora Serial',
  },
]

export default function Register() {
  const [current, setCurrent] = useState(0)

  return (
    <div className="min-h-screen flex">
      {/* Columna izquierda */}
      <div className="hidden md:flex flex-col justify-center items-start flex-1 bg-gradient-to-br from-[#6366F1] to-[#4338CA] px-16">
        <h1 className="text-4xl font-extrabold text-white mb-8">Bienvenido a Validea</h1>
        <blockquote className="text-white text-xl font-light mb-6 max-w-lg">“{phrases[current].quote}”</blockquote>
        <div className="mb-2">
          <span className="text-white font-semibold">{phrases[current].author}</span><br />
          <span className="text-white text-sm">{phrases[current].role}</span>
        </div>
        {/* Slider dots */}
        <div className="flex gap-2 mt-6">
          {phrases.map((_, idx) => (
            <button
              key={idx}
              className={`h-3 w-3 rounded-full border-2 ${current === idx ? 'bg-white border-white' : 'bg-transparent border-white opacity-60'} transition-all`}
              onClick={() => setCurrent(idx)}
              aria-label={`Frase ${idx + 1}`}
            />
          ))}
        </div>
      </div>
      {/* Columna derecha */}
      <div className="flex-1 flex items-center justify-center bg-white">
        <div className="w-full max-w-md bg-white rounded-2xl shadow-xl p-8">
          <h2 className="text-3xl font-bold text-[#6366F1] text-center mb-2">Validea</h2>
          <h3 className="text-xl font-semibold text-gray-900 text-center mb-1">Crea tu cuenta</h3>
          <p className="text-center text-gray-500 text-sm mb-6">
            El registro está <span className="text-[#6366F1] font-semibold">deshabilitado temporalmente por beta</span>.<br />
            ¿Ya tienes una cuenta?{' '}
            <Link to="/login" className="text-[#6366F1] hover:underline">Inicia sesión aquí</Link>
          </p>
          <form className="space-y-4">
            <div>
              <label htmlFor="email" className="block text-sm font-medium text-gray-700">Correo electrónico</label>
              <input type="email" id="email" name="email" disabled placeholder="tu@email.com" className="mt-1 w-full rounded-md border border-gray-300 px-3 py-2 bg-gray-100 text-gray-400" />
            </div>
            <div>
              <label htmlFor="password" className="block text-sm font-medium text-gray-700">Contraseña</label>
              <input type="password" id="password" name="password" disabled className="mt-1 w-full rounded-md border border-gray-300 px-3 py-2 bg-gray-100 text-gray-400" />
            </div>
            <div>
              <label htmlFor="confirm" className="block text-sm font-medium text-gray-700">Confirmar contraseña</label>
              <input type="password" id="confirm" name="confirm" disabled className="mt-1 w-full rounded-md border border-gray-300 px-3 py-2 bg-gray-100 text-gray-400" />
            </div>
            <button type="button" disabled className="w-full bg-gray-300 text-gray-500 font-semibold py-2 rounded-md mt-2 cursor-not-allowed">Registro deshabilitado</button>
          </form>
        </div>
      </div>
    </div>
  )
} 